export class Translation {
	nlBe:string | null = null;
	fr:string | null = null;
	en:string | null = null;
	Fallback:string = "";

	constructor(data?:any){
		if (!data) return;
		this.nlBe = data["nl-be"];
		this.fr = data.fr;
		this.en = data.en;
		this.Fallback = data.Fallback;
	}

	private static getString(val:string|null):string|null{
		if (val == null) return null;
		if (/^\s*$/.test(val)){
			return null;
		}
		return val;
	}

	getFallback():string{
		let order = [this.nlBe, this.en, this.fr];
		for (let lang of order){
			let val = Translation.getString(lang);
			if (val != null){
				return val;
			}
		}
		return "";
	}

	getJSON(){
		return {
			"nl-be": Translation.getString(this.nlBe),
			fr: Translation.getString(this.fr),
			en: Translation.getString(this.en),
			Fallback: this.getFallback()
		};
	}
}